/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CheckPlayableAdsExistResponse,
  ClaimCheckpointRewardResponse,
  ClaimQuestRewardResponse,
  DataSource,
  FormError,
  GetAllQuestConfigsForUserResponse,
  GetAllQuestConfigsForUserSort,
  GetPhotoSubmissionsResponse,
  GetPhotoSubmissionsSort,
  GetPhotoSubmissionsStatus,
  GetQuestConfigsResponse,
  GetQuestConfigsSort,
  GetQuestLeaderboardsResponse,
  GetQuestLeaderboardsSort,
  GetQuestPhotoRequirementsResponse,
  GetQuestPhotosCountResponse,
  PhotoType,
  QuestConfig,
  QuestConfigBody,
  QuestConfigResponse,
  QuestConfigWithGameMetadata,
  QuestDisplay,
  QuestProgression,
  QuestReset,
  RedeemCodeBody,
  RedeemCodeResponse,
  SortOrder,
  UpdateQuestConfigPrerequisitesBody,
  ValidateScanBody,
  ValidateScanResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CheckPlayableAdsExistResponseFromJSON,
    CheckPlayableAdsExistResponseToJSON,
    ClaimCheckpointRewardResponseFromJSON,
    ClaimCheckpointRewardResponseToJSON,
    ClaimQuestRewardResponseFromJSON,
    ClaimQuestRewardResponseToJSON,
    DataSourceFromJSON,
    DataSourceToJSON,
    FormErrorFromJSON,
    FormErrorToJSON,
    GetAllQuestConfigsForUserResponseFromJSON,
    GetAllQuestConfigsForUserResponseToJSON,
    GetAllQuestConfigsForUserSortFromJSON,
    GetAllQuestConfigsForUserSortToJSON,
    GetPhotoSubmissionsResponseFromJSON,
    GetPhotoSubmissionsResponseToJSON,
    GetPhotoSubmissionsSortFromJSON,
    GetPhotoSubmissionsSortToJSON,
    GetPhotoSubmissionsStatusFromJSON,
    GetPhotoSubmissionsStatusToJSON,
    GetQuestConfigsResponseFromJSON,
    GetQuestConfigsResponseToJSON,
    GetQuestConfigsSortFromJSON,
    GetQuestConfigsSortToJSON,
    GetQuestLeaderboardsResponseFromJSON,
    GetQuestLeaderboardsResponseToJSON,
    GetQuestLeaderboardsSortFromJSON,
    GetQuestLeaderboardsSortToJSON,
    GetQuestPhotoRequirementsResponseFromJSON,
    GetQuestPhotoRequirementsResponseToJSON,
    GetQuestPhotosCountResponseFromJSON,
    GetQuestPhotosCountResponseToJSON,
    PhotoTypeFromJSON,
    PhotoTypeToJSON,
    QuestConfigFromJSON,
    QuestConfigToJSON,
    QuestConfigBodyFromJSON,
    QuestConfigBodyToJSON,
    QuestConfigResponseFromJSON,
    QuestConfigResponseToJSON,
    QuestConfigWithGameMetadataFromJSON,
    QuestConfigWithGameMetadataToJSON,
    QuestDisplayFromJSON,
    QuestDisplayToJSON,
    QuestProgressionFromJSON,
    QuestProgressionToJSON,
    QuestResetFromJSON,
    QuestResetToJSON,
    RedeemCodeBodyFromJSON,
    RedeemCodeBodyToJSON,
    RedeemCodeResponseFromJSON,
    RedeemCodeResponseToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
    UpdateQuestConfigPrerequisitesBodyFromJSON,
    UpdateQuestConfigPrerequisitesBodyToJSON,
    ValidateScanBodyFromJSON,
    ValidateScanBodyToJSON,
    ValidateScanResponseFromJSON,
    ValidateScanResponseToJSON,
} from '../models/index';

export interface CreateEventPipelineQuestPhotosIdRequest {
    id: string;
    body?: object;
}

export interface CreateEventPipelineRedeemCodeRequest {
    redeemCodeBody: RedeemCodeBody;
}

export interface CreateEventPipelineValidateScanRequest {
    validateScanBody: ValidateScanBody;
}

export interface CreateQueryPhotoAnalysisRequest {
    prompt: string;
    schema: string;
    screenshotUrl?: string;
    photoType?: PhotoType;
    photo?: Blob;
}

export interface CreateQuestConfigsRequest {
    questConfigBody?: QuestConfigBody;
}

export interface CreateQuestConfigsIdClaimRewardRequest {
    id: string;
}

export interface CreateQuestConfigsQuestConfigIdMilestonesMilestoneIdCheckpointsThresholdClaimRequest {
    questConfigId: string;
    milestoneId: string;
    threshold: number;
}

export interface DeleteEventPipelineQuestPhotosIdRequest {
    id: string;
}

export interface DeleteQuestConfigsIdRequest {
    id: string;
}

export interface GetEventPipelineGetPhotoRequirementsRequest {
    photoType: PhotoType;
}

export interface GetEventPipelineGetQuestPhotosRequest {
    userIds?: Array<string>;
    type?: PhotoType;
    status?: GetPhotoSubmissionsStatus;
    sort?: GetPhotoSubmissionsSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetEventPipelineGetQuestPhotosCountRequest {
    photoType: PhotoType;
}

export interface GetQuestConfigsRequest {
    search?: string;
    questConfigIds?: Array<string>;
    gameId?: string;
    questReset?: QuestReset;
    isActive?: GetQuestConfigsIsActiveEnum;
    isSponsored?: GetQuestConfigsIsSponsoredEnum;
    rewardType?: Array<string>;
    sort?: GetQuestConfigsSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetQuestConfigsIdLeaderboardRequest {
    id: string;
    sort?: GetQuestLeaderboardsSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetQuestConfigsIdSingleRequest {
    id: string;
}

export interface GetQuestConfigsPlayableAdsRequest {
    utmSource: string;
    gameId?: string;
    externalGameId?: string;
    limit?: number;
    isActive?: GetQuestConfigsPlayableAdsIsActiveEnum;
}

export interface GetQuestConfigsPlayableAdsExistsRequest {
    utmSource: string;
    gameId?: string;
    externalGameId?: string;
    limit?: number;
    isActive?: GetQuestConfigsPlayableAdsExistsIsActiveEnum;
}

export interface GetQuestConfigsUserRequest {
    gameId?: string;
    guildId?: string;
    source?: DataSource;
    surface?: QuestDisplay;
}

export interface GetQuestConfigsUserAllRequest {
    sort?: GetAllQuestConfigsForUserSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetQuestProgressionRequest {
    questConfigIds?: Array<string>;
    challengeId?: string;
    challengeSlug?: string;
}

export interface UpdateQuestConfigsIdRequest {
    id: string;
    questConfigBody?: QuestConfigBody;
}

export interface UpdateQuestConfigsIdPrerequisitesRequest {
    id: string;
    updateQuestConfigPrerequisitesBody?: UpdateQuestConfigPrerequisitesBody;
}

/**
 * QuestsApi - interface
 * 
 * @export
 * @interface QuestsApiInterface
 */
export interface QuestsApiInterface {
    /**
     * Allow admin to manually accept photo submission.
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    createEventPipelineQuestPhotosIdRaw(requestParameters: CreateEventPipelineQuestPhotosIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Allow admin to manually accept photo submission.
     */
    createEventPipelineQuestPhotosId(requestParameters: CreateEventPipelineQuestPhotosIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Redeem a promo code to complete a CODE_ENTRY milestone
     * @param {RedeemCodeBody} redeemCodeBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    createEventPipelineRedeemCodeRaw(requestParameters: CreateEventPipelineRedeemCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RedeemCodeResponse>>;

    /**
     * Redeem a promo code to complete a CODE_ENTRY milestone
     */
    createEventPipelineRedeemCode(requestParameters: CreateEventPipelineRedeemCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RedeemCodeResponse>;

    /**
     * Validate a QR code scan to complete a QR_SCAN milestone
     * @param {ValidateScanBody} validateScanBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    createEventPipelineValidateScanRaw(requestParameters: CreateEventPipelineValidateScanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateScanResponse>>;

    /**
     * Validate a QR code scan to complete a QR_SCAN milestone
     */
    createEventPipelineValidateScan(requestParameters: CreateEventPipelineValidateScanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateScanResponse>;

    /**
     * User Google AI to ask questions about an image. Return the result in a standardized format.
     * @param {string} prompt 
     * @param {string} schema 
     * @param {string} [screenshotUrl] 
     * @param {PhotoType} [photoType] 
     * @param {Blob} [photo] The photo file to validate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    createQueryPhotoAnalysisRaw(requestParameters: CreateQueryPhotoAnalysisRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>>;

    /**
     * User Google AI to ask questions about an image. Return the result in a standardized format.
     */
    createQueryPhotoAnalysis(requestParameters: CreateQueryPhotoAnalysisRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object>;

    /**
     * Used by admins to create new quest configs.
     * @param {QuestConfigBody} [questConfigBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    createQuestConfigsRaw(requestParameters: CreateQuestConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuestConfig>>;

    /**
     * Used by admins to create new quest configs.
     */
    createQuestConfigs(requestParameters: CreateQuestConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuestConfig>;

    /**
     * Claims a completed quest reward.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    createQuestConfigsIdClaimRewardRaw(requestParameters: CreateQuestConfigsIdClaimRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimQuestRewardResponse>>;

    /**
     * Claims a completed quest reward.
     */
    createQuestConfigsIdClaimReward(requestParameters: CreateQuestConfigsIdClaimRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimQuestRewardResponse>;

    /**
     * Claims a completed checkpoint reward
     * @param {string} questConfigId 
     * @param {string} milestoneId 
     * @param {number} threshold 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    createQuestConfigsQuestConfigIdMilestonesMilestoneIdCheckpointsThresholdClaimRaw(requestParameters: CreateQuestConfigsQuestConfigIdMilestonesMilestoneIdCheckpointsThresholdClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimCheckpointRewardResponse>>;

    /**
     * Claims a completed checkpoint reward
     */
    createQuestConfigsQuestConfigIdMilestonesMilestoneIdCheckpointsThresholdClaim(requestParameters: CreateQuestConfigsQuestConfigIdMilestonesMilestoneIdCheckpointsThresholdClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimCheckpointRewardResponse>;

    /**
     * Allow admin to manually reject photo submission.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    deleteEventPipelineQuestPhotosIdRaw(requestParameters: DeleteEventPipelineQuestPhotosIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Allow admin to manually reject photo submission.
     */
    deleteEventPipelineQuestPhotosId(requestParameters: DeleteEventPipelineQuestPhotosIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by admins to delete existing quest configs.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    deleteQuestConfigsIdRaw(requestParameters: DeleteQuestConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by admins to delete existing quest configs.
     */
    deleteQuestConfigsId(requestParameters: DeleteQuestConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Gets the rules for the specific photo requirement
     * @param {PhotoType} photoType The type of vehicle in the photo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    getEventPipelineGetPhotoRequirementsRaw(requestParameters: GetEventPipelineGetPhotoRequirementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetQuestPhotoRequirementsResponse>>;

    /**
     * Gets the rules for the specific photo requirement
     */
    getEventPipelineGetPhotoRequirements(requestParameters: GetEventPipelineGetPhotoRequirementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetQuestPhotoRequirementsResponse>;

    /**
     * Gets all photo upload submissions.
     * @param {Array<string>} [userIds] 
     * @param {PhotoType} [type] 
     * @param {GetPhotoSubmissionsStatus} [status] 
     * @param {GetPhotoSubmissionsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    getEventPipelineGetQuestPhotosRaw(requestParameters: GetEventPipelineGetQuestPhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPhotoSubmissionsResponse>>;

    /**
     * Gets all photo upload submissions.
     */
    getEventPipelineGetQuestPhotos(requestParameters: GetEventPipelineGetQuestPhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPhotoSubmissionsResponse>;

    /**
     * Gets a summary of a user\'s quest photo submissions
     * @param {PhotoType} photoType The type of vehicle in the photo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    getEventPipelineGetQuestPhotosCountRaw(requestParameters: GetEventPipelineGetQuestPhotosCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetQuestPhotosCountResponse>>;

    /**
     * Gets a summary of a user\'s quest photo submissions
     */
    getEventPipelineGetQuestPhotosCount(requestParameters: GetEventPipelineGetQuestPhotosCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetQuestPhotosCountResponse>;

    /**
     * Used to get a list of all quest configs
     * @param {string} [search] Search quest names (case-insensitive regex)
     * @param {Array<string>} [questConfigIds] Filter by specific quest config IDs
     * @param {string} [gameId] Filter by game ID
     * @param {QuestReset} [questReset] Filter by reset type (DAILY, WEEKLY, MONTHLY, NONE)
     * @param {'true' | 'false' | 'all'} [isActive] Filter by active status (defaults to all)
     * @param {'true' | 'false' | 'all'} [isSponsored] Filter by sponsored status (defaults to all)
     * @param {Array<string>} [rewardType] Filter by reward types present in quest OR milestones
     * @param {GetQuestConfigsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    getQuestConfigsRaw(requestParameters: GetQuestConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetQuestConfigsResponse>>;

    /**
     * Used to get a list of all quest configs
     */
    getQuestConfigs(requestParameters: GetQuestConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetQuestConfigsResponse>;

    /**
     * Used to get quest progress for specific quest and user.
     * @param {string} id 
     * @param {GetQuestLeaderboardsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    getQuestConfigsIdLeaderboardRaw(requestParameters: GetQuestConfigsIdLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetQuestLeaderboardsResponse>>;

    /**
     * Used to get quest progress for specific quest and user.
     */
    getQuestConfigsIdLeaderboard(requestParameters: GetQuestConfigsIdLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetQuestLeaderboardsResponse>;

    /**
     * Get existing quest config. Admin only — returns the complete config, including unreleased and inactive quests.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    getQuestConfigsIdSingleRaw(requestParameters: GetQuestConfigsIdSingleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuestConfigResponse>>;

    /**
     * Get existing quest config. Admin only — returns the complete config, including unreleased and inactive quests.
     */
    getQuestConfigsIdSingle(requestParameters: GetQuestConfigsIdSingleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuestConfigResponse>;

    /**
     * Get quest configs for playable ads on partner sites (Blitz.gg, etc.). Returns quests with matching milestone sources for ad display. Does NOT apply user-specific filters (prerequisites checked on interaction). 
     * @param {string} utmSource UTM source to filter by (e.g., blitz)
     * @param {string} [gameId] Optional filter by specific game ID
     * @param {string} [externalGameId] Optional filter by specific external game ID
     * @param {number} [limit] Maximum number of results
     * @param {'true' | 'false' | 'all'} [isActive] Filter by active status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    getQuestConfigsPlayableAdsRaw(requestParameters: GetQuestConfigsPlayableAdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<QuestConfigWithGameMetadata>>>;

    /**
     * Get quest configs for playable ads on partner sites (Blitz.gg, etc.). Returns quests with matching milestone sources for ad display. Does NOT apply user-specific filters (prerequisites checked on interaction). 
     */
    getQuestConfigsPlayableAds(requestParameters: GetQuestConfigsPlayableAdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<QuestConfigWithGameMetadata>>;

    /**
     * Check whether any playable ads exist for the given source and game context. Handles capped/uncapped activations and authenticated user completion state. 
     * @param {string} utmSource UTM source to filter by (e.g., blitz)
     * @param {string} [gameId] Optional filter by specific game ID
     * @param {string} [externalGameId] Optional filter by specific external game ID
     * @param {number} [limit] Maximum number of results
     * @param {'true' | 'false' | 'all'} [isActive] Filter by active status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    getQuestConfigsPlayableAdsExistsRaw(requestParameters: GetQuestConfigsPlayableAdsExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckPlayableAdsExistResponse>>;

    /**
     * Check whether any playable ads exist for the given source and game context. Handles capped/uncapped activations and authenticated user completion state. 
     */
    getQuestConfigsPlayableAdsExists(requestParameters: GetQuestConfigsPlayableAdsExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckPlayableAdsExistResponse>;

    /**
     * Used to get a list of qualified quest configs for specific game and user. Applies active brand sponsorships if applicable.
     * @param {string} [gameId] 
     * @param {string} [guildId] 
     * @param {DataSource} [source] Optional data source filter for brand sponsorships (BLITZ, OVERWOLF, STEAM, CONSOLE)
     * @param {QuestDisplay} [surface] Platform surface to fetch quests for (e.g. PLAY_PAGE for home-page onboarding quests). Mutually exclusive with gameId/guildId.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    getQuestConfigsUserRaw(requestParameters: GetQuestConfigsUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<QuestConfigResponse>>>;

    /**
     * Used to get a list of qualified quest configs for specific game and user. Applies active brand sponsorships if applicable.
     */
    getQuestConfigsUser(requestParameters: GetQuestConfigsUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<QuestConfigResponse>>;

    /**
     * Used to get all qualified quest configs across all games for the user. Specifically for Quest Progress Card \"All Games\" functionality.
     * @param {GetAllQuestConfigsForUserSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    getQuestConfigsUserAllRaw(requestParameters: GetQuestConfigsUserAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllQuestConfigsForUserResponse>>;

    /**
     * Used to get all qualified quest configs across all games for the user. Specifically for Quest Progress Card \"All Games\" functionality.
     */
    getQuestConfigsUserAll(requestParameters: GetQuestConfigsUserAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllQuestConfigsForUserResponse>;

    /**
     * Used to get quest progress for specific quest and user.
     * @param {Array<string>} [questConfigIds] 
     * @param {string} [challengeId] 
     * @param {string} [challengeSlug] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    getQuestProgressionRaw(requestParameters: GetQuestProgressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<QuestProgression>>>;

    /**
     * Used to get quest progress for specific quest and user.
     */
    getQuestProgression(requestParameters: GetQuestProgressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<QuestProgression>>;

    /**
     * Used by admins to update existing quest configs.
     * @param {string} id 
     * @param {QuestConfigBody} [questConfigBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    updateQuestConfigsIdRaw(requestParameters: UpdateQuestConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuestConfig>>;

    /**
     * Used by admins to update existing quest configs.
     */
    updateQuestConfigsId(requestParameters: UpdateQuestConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuestConfig>;

    /**
     * Replace only a quest config\'s prerequisites (the Journey Editor\'s edge write). Milestones, rewards, and all other fields are left untouched.
     * @param {string} id 
     * @param {UpdateQuestConfigPrerequisitesBody} [updateQuestConfigPrerequisitesBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    updateQuestConfigsIdPrerequisitesRaw(requestParameters: UpdateQuestConfigsIdPrerequisitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuestConfigResponse>>;

    /**
     * Replace only a quest config\'s prerequisites (the Journey Editor\'s edge write). Milestones, rewards, and all other fields are left untouched.
     */
    updateQuestConfigsIdPrerequisites(requestParameters: UpdateQuestConfigsIdPrerequisitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuestConfigResponse>;

}

/**
 * 
 */
export class QuestsApi extends runtime.BaseAPI implements QuestsApiInterface {

    /**
     * Allow admin to manually accept photo submission.
     */
    async createEventPipelineQuestPhotosIdRaw(requestParameters: CreateEventPipelineQuestPhotosIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createEventPipelineQuestPhotosId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/event-pipeline/quest-photos/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Allow admin to manually accept photo submission.
     */
    async createEventPipelineQuestPhotosId(requestParameters: CreateEventPipelineQuestPhotosIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createEventPipelineQuestPhotosIdRaw(requestParameters, initOverrides);
    }

    /**
     * Redeem a promo code to complete a CODE_ENTRY milestone
     */
    async createEventPipelineRedeemCodeRaw(requestParameters: CreateEventPipelineRedeemCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RedeemCodeResponse>> {
        if (requestParameters['redeemCodeBody'] == null) {
            throw new runtime.RequiredError(
                'redeemCodeBody',
                'Required parameter "redeemCodeBody" was null or undefined when calling createEventPipelineRedeemCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/event-pipeline/redeem-code`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RedeemCodeBodyToJSON(requestParameters['redeemCodeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RedeemCodeResponseFromJSON(jsonValue));
    }

    /**
     * Redeem a promo code to complete a CODE_ENTRY milestone
     */
    async createEventPipelineRedeemCode(requestParameters: CreateEventPipelineRedeemCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RedeemCodeResponse> {
        const response = await this.createEventPipelineRedeemCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate a QR code scan to complete a QR_SCAN milestone
     */
    async createEventPipelineValidateScanRaw(requestParameters: CreateEventPipelineValidateScanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateScanResponse>> {
        if (requestParameters['validateScanBody'] == null) {
            throw new runtime.RequiredError(
                'validateScanBody',
                'Required parameter "validateScanBody" was null or undefined when calling createEventPipelineValidateScan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/event-pipeline/validate-scan`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateScanBodyToJSON(requestParameters['validateScanBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidateScanResponseFromJSON(jsonValue));
    }

    /**
     * Validate a QR code scan to complete a QR_SCAN milestone
     */
    async createEventPipelineValidateScan(requestParameters: CreateEventPipelineValidateScanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateScanResponse> {
        const response = await this.createEventPipelineValidateScanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * User Google AI to ask questions about an image. Return the result in a standardized format.
     */
    async createQueryPhotoAnalysisRaw(requestParameters: CreateQueryPhotoAnalysisRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['prompt'] == null) {
            throw new runtime.RequiredError(
                'prompt',
                'Required parameter "prompt" was null or undefined when calling createQueryPhotoAnalysis().'
            );
        }

        if (requestParameters['schema'] == null) {
            throw new runtime.RequiredError(
                'schema',
                'Required parameter "schema" was null or undefined when calling createQueryPhotoAnalysis().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['screenshotUrl'] != null) {
            formParams.append('screenshotUrl', requestParameters['screenshotUrl'] as any);
        }

        if (requestParameters['prompt'] != null) {
            formParams.append('prompt', requestParameters['prompt'] as any);
        }

        if (requestParameters['schema'] != null) {
            formParams.append('schema', requestParameters['schema'] as any);
        }

        if (requestParameters['photoType'] != null) {
            formParams.append('photoType', requestParameters['photoType'] as any);
        }

        if (requestParameters['photo'] != null) {
            formParams.append('photo', requestParameters['photo'] as any);
        }


        let urlPath = `/query-photo-analysis`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * User Google AI to ask questions about an image. Return the result in a standardized format.
     */
    async createQueryPhotoAnalysis(requestParameters: CreateQueryPhotoAnalysisRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.createQueryPhotoAnalysisRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by admins to create new quest configs.
     */
    async createQuestConfigsRaw(requestParameters: CreateQuestConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuestConfig>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/quest-configs`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QuestConfigBodyToJSON(requestParameters['questConfigBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuestConfigFromJSON(jsonValue));
    }

    /**
     * Used by admins to create new quest configs.
     */
    async createQuestConfigs(requestParameters: CreateQuestConfigsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuestConfig> {
        const response = await this.createQuestConfigsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Claims a completed quest reward.
     */
    async createQuestConfigsIdClaimRewardRaw(requestParameters: CreateQuestConfigsIdClaimRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimQuestRewardResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createQuestConfigsIdClaimReward().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/quest-configs/{id}/claim-reward`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimQuestRewardResponseFromJSON(jsonValue));
    }

    /**
     * Claims a completed quest reward.
     */
    async createQuestConfigsIdClaimReward(requestParameters: CreateQuestConfigsIdClaimRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimQuestRewardResponse> {
        const response = await this.createQuestConfigsIdClaimRewardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Claims a completed checkpoint reward
     */
    async createQuestConfigsQuestConfigIdMilestonesMilestoneIdCheckpointsThresholdClaimRaw(requestParameters: CreateQuestConfigsQuestConfigIdMilestonesMilestoneIdCheckpointsThresholdClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimCheckpointRewardResponse>> {
        if (requestParameters['questConfigId'] == null) {
            throw new runtime.RequiredError(
                'questConfigId',
                'Required parameter "questConfigId" was null or undefined when calling createQuestConfigsQuestConfigIdMilestonesMilestoneIdCheckpointsThresholdClaim().'
            );
        }

        if (requestParameters['milestoneId'] == null) {
            throw new runtime.RequiredError(
                'milestoneId',
                'Required parameter "milestoneId" was null or undefined when calling createQuestConfigsQuestConfigIdMilestonesMilestoneIdCheckpointsThresholdClaim().'
            );
        }

        if (requestParameters['threshold'] == null) {
            throw new runtime.RequiredError(
                'threshold',
                'Required parameter "threshold" was null or undefined when calling createQuestConfigsQuestConfigIdMilestonesMilestoneIdCheckpointsThresholdClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/quest-configs/{questConfigId}/milestones/{milestoneId}/checkpoints/{threshold}/claim`;
        urlPath = urlPath.replace(`{${"questConfigId"}}`, encodeURIComponent(String(requestParameters['questConfigId'])));
        urlPath = urlPath.replace(`{${"milestoneId"}}`, encodeURIComponent(String(requestParameters['milestoneId'])));
        urlPath = urlPath.replace(`{${"threshold"}}`, encodeURIComponent(String(requestParameters['threshold'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimCheckpointRewardResponseFromJSON(jsonValue));
    }

    /**
     * Claims a completed checkpoint reward
     */
    async createQuestConfigsQuestConfigIdMilestonesMilestoneIdCheckpointsThresholdClaim(requestParameters: CreateQuestConfigsQuestConfigIdMilestonesMilestoneIdCheckpointsThresholdClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimCheckpointRewardResponse> {
        const response = await this.createQuestConfigsQuestConfigIdMilestonesMilestoneIdCheckpointsThresholdClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Allow admin to manually reject photo submission.
     */
    async deleteEventPipelineQuestPhotosIdRaw(requestParameters: DeleteEventPipelineQuestPhotosIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteEventPipelineQuestPhotosId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/event-pipeline/quest-photos/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Allow admin to manually reject photo submission.
     */
    async deleteEventPipelineQuestPhotosId(requestParameters: DeleteEventPipelineQuestPhotosIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEventPipelineQuestPhotosIdRaw(requestParameters, initOverrides);
    }

    /**
     * Used by admins to delete existing quest configs.
     */
    async deleteQuestConfigsIdRaw(requestParameters: DeleteQuestConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteQuestConfigsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/quest-configs/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by admins to delete existing quest configs.
     */
    async deleteQuestConfigsId(requestParameters: DeleteQuestConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteQuestConfigsIdRaw(requestParameters, initOverrides);
    }

    /**
     * Gets the rules for the specific photo requirement
     */
    async getEventPipelineGetPhotoRequirementsRaw(requestParameters: GetEventPipelineGetPhotoRequirementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetQuestPhotoRequirementsResponse>> {
        if (requestParameters['photoType'] == null) {
            throw new runtime.RequiredError(
                'photoType',
                'Required parameter "photoType" was null or undefined when calling getEventPipelineGetPhotoRequirements().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['photoType'] != null) {
            queryParameters['photoType'] = requestParameters['photoType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/event-pipeline/get-photo-requirements`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetQuestPhotoRequirementsResponseFromJSON(jsonValue));
    }

    /**
     * Gets the rules for the specific photo requirement
     */
    async getEventPipelineGetPhotoRequirements(requestParameters: GetEventPipelineGetPhotoRequirementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetQuestPhotoRequirementsResponse> {
        const response = await this.getEventPipelineGetPhotoRequirementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets all photo upload submissions.
     */
    async getEventPipelineGetQuestPhotosRaw(requestParameters: GetEventPipelineGetQuestPhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPhotoSubmissionsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['userIds'] != null) {
            queryParameters['userIds'] = requestParameters['userIds'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/event-pipeline/get-quest-photos`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPhotoSubmissionsResponseFromJSON(jsonValue));
    }

    /**
     * Gets all photo upload submissions.
     */
    async getEventPipelineGetQuestPhotos(requestParameters: GetEventPipelineGetQuestPhotosRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPhotoSubmissionsResponse> {
        const response = await this.getEventPipelineGetQuestPhotosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a summary of a user\'s quest photo submissions
     */
    async getEventPipelineGetQuestPhotosCountRaw(requestParameters: GetEventPipelineGetQuestPhotosCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetQuestPhotosCountResponse>> {
        if (requestParameters['photoType'] == null) {
            throw new runtime.RequiredError(
                'photoType',
                'Required parameter "photoType" was null or undefined when calling getEventPipelineGetQuestPhotosCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['photoType'] != null) {
            queryParameters['photoType'] = requestParameters['photoType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/event-pipeline/get-quest-photos-count`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetQuestPhotosCountResponseFromJSON(jsonValue));
    }

    /**
     * Gets a summary of a user\'s quest photo submissions
     */
    async getEventPipelineGetQuestPhotosCount(requestParameters: GetEventPipelineGetQuestPhotosCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetQuestPhotosCountResponse> {
        const response = await this.getEventPipelineGetQuestPhotosCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get a list of all quest configs
     */
    async getQuestConfigsRaw(requestParameters: GetQuestConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetQuestConfigsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['questConfigIds'] != null) {
            queryParameters['questConfigIds'] = requestParameters['questConfigIds'];
        }

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['questReset'] != null) {
            queryParameters['questReset'] = requestParameters['questReset'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        if (requestParameters['isSponsored'] != null) {
            queryParameters['isSponsored'] = requestParameters['isSponsored'];
        }

        if (requestParameters['rewardType'] != null) {
            queryParameters['rewardType'] = requestParameters['rewardType'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/quest-configs`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetQuestConfigsResponseFromJSON(jsonValue));
    }

    /**
     * Used to get a list of all quest configs
     */
    async getQuestConfigs(requestParameters: GetQuestConfigsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetQuestConfigsResponse> {
        const response = await this.getQuestConfigsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get quest progress for specific quest and user.
     */
    async getQuestConfigsIdLeaderboardRaw(requestParameters: GetQuestConfigsIdLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetQuestLeaderboardsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getQuestConfigsIdLeaderboard().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/quest-configs/{id}/leaderboard`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetQuestLeaderboardsResponseFromJSON(jsonValue));
    }

    /**
     * Used to get quest progress for specific quest and user.
     */
    async getQuestConfigsIdLeaderboard(requestParameters: GetQuestConfigsIdLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetQuestLeaderboardsResponse> {
        const response = await this.getQuestConfigsIdLeaderboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get existing quest config. Admin only — returns the complete config, including unreleased and inactive quests.
     */
    async getQuestConfigsIdSingleRaw(requestParameters: GetQuestConfigsIdSingleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuestConfigResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getQuestConfigsIdSingle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/quest-configs/{id}/single`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuestConfigResponseFromJSON(jsonValue));
    }

    /**
     * Get existing quest config. Admin only — returns the complete config, including unreleased and inactive quests.
     */
    async getQuestConfigsIdSingle(requestParameters: GetQuestConfigsIdSingleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuestConfigResponse> {
        const response = await this.getQuestConfigsIdSingleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get quest configs for playable ads on partner sites (Blitz.gg, etc.). Returns quests with matching milestone sources for ad display. Does NOT apply user-specific filters (prerequisites checked on interaction). 
     */
    async getQuestConfigsPlayableAdsRaw(requestParameters: GetQuestConfigsPlayableAdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<QuestConfigWithGameMetadata>>> {
        if (requestParameters['utmSource'] == null) {
            throw new runtime.RequiredError(
                'utmSource',
                'Required parameter "utmSource" was null or undefined when calling getQuestConfigsPlayableAds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['utmSource'] != null) {
            queryParameters['utmSource'] = requestParameters['utmSource'];
        }

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['externalGameId'] != null) {
            queryParameters['externalGameId'] = requestParameters['externalGameId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/quest-configs/playable-ads`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(QuestConfigWithGameMetadataFromJSON));
    }

    /**
     * Get quest configs for playable ads on partner sites (Blitz.gg, etc.). Returns quests with matching milestone sources for ad display. Does NOT apply user-specific filters (prerequisites checked on interaction). 
     */
    async getQuestConfigsPlayableAds(requestParameters: GetQuestConfigsPlayableAdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<QuestConfigWithGameMetadata>> {
        const response = await this.getQuestConfigsPlayableAdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether any playable ads exist for the given source and game context. Handles capped/uncapped activations and authenticated user completion state. 
     */
    async getQuestConfigsPlayableAdsExistsRaw(requestParameters: GetQuestConfigsPlayableAdsExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckPlayableAdsExistResponse>> {
        if (requestParameters['utmSource'] == null) {
            throw new runtime.RequiredError(
                'utmSource',
                'Required parameter "utmSource" was null or undefined when calling getQuestConfigsPlayableAdsExists().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['utmSource'] != null) {
            queryParameters['utmSource'] = requestParameters['utmSource'];
        }

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['externalGameId'] != null) {
            queryParameters['externalGameId'] = requestParameters['externalGameId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/quest-configs/playable-ads/exists`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckPlayableAdsExistResponseFromJSON(jsonValue));
    }

    /**
     * Check whether any playable ads exist for the given source and game context. Handles capped/uncapped activations and authenticated user completion state. 
     */
    async getQuestConfigsPlayableAdsExists(requestParameters: GetQuestConfigsPlayableAdsExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckPlayableAdsExistResponse> {
        const response = await this.getQuestConfigsPlayableAdsExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get a list of qualified quest configs for specific game and user. Applies active brand sponsorships if applicable.
     */
    async getQuestConfigsUserRaw(requestParameters: GetQuestConfigsUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<QuestConfigResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['guildId'] != null) {
            queryParameters['guildId'] = requestParameters['guildId'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        if (requestParameters['surface'] != null) {
            queryParameters['surface'] = requestParameters['surface'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/quest-configs/user`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(QuestConfigResponseFromJSON));
    }

    /**
     * Used to get a list of qualified quest configs for specific game and user. Applies active brand sponsorships if applicable.
     */
    async getQuestConfigsUser(requestParameters: GetQuestConfigsUserRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<QuestConfigResponse>> {
        const response = await this.getQuestConfigsUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get all qualified quest configs across all games for the user. Specifically for Quest Progress Card \"All Games\" functionality.
     */
    async getQuestConfigsUserAllRaw(requestParameters: GetQuestConfigsUserAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllQuestConfigsForUserResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/quest-configs/user/all`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAllQuestConfigsForUserResponseFromJSON(jsonValue));
    }

    /**
     * Used to get all qualified quest configs across all games for the user. Specifically for Quest Progress Card \"All Games\" functionality.
     */
    async getQuestConfigsUserAll(requestParameters: GetQuestConfigsUserAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllQuestConfigsForUserResponse> {
        const response = await this.getQuestConfigsUserAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get quest progress for specific quest and user.
     */
    async getQuestProgressionRaw(requestParameters: GetQuestProgressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<QuestProgression>>> {
        const queryParameters: any = {};

        if (requestParameters['questConfigIds'] != null) {
            queryParameters['questConfigIds'] = requestParameters['questConfigIds'];
        }

        if (requestParameters['challengeId'] != null) {
            queryParameters['challengeId'] = requestParameters['challengeId'];
        }

        if (requestParameters['challengeSlug'] != null) {
            queryParameters['challengeSlug'] = requestParameters['challengeSlug'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/quest-progression`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(QuestProgressionFromJSON));
    }

    /**
     * Used to get quest progress for specific quest and user.
     */
    async getQuestProgression(requestParameters: GetQuestProgressionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<QuestProgression>> {
        const response = await this.getQuestProgressionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by admins to update existing quest configs.
     */
    async updateQuestConfigsIdRaw(requestParameters: UpdateQuestConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuestConfig>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateQuestConfigsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/quest-configs/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: QuestConfigBodyToJSON(requestParameters['questConfigBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuestConfigFromJSON(jsonValue));
    }

    /**
     * Used by admins to update existing quest configs.
     */
    async updateQuestConfigsId(requestParameters: UpdateQuestConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuestConfig> {
        const response = await this.updateQuestConfigsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace only a quest config\'s prerequisites (the Journey Editor\'s edge write). Milestones, rewards, and all other fields are left untouched.
     */
    async updateQuestConfigsIdPrerequisitesRaw(requestParameters: UpdateQuestConfigsIdPrerequisitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuestConfigResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateQuestConfigsIdPrerequisites().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/quest-configs/{id}/prerequisites`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateQuestConfigPrerequisitesBodyToJSON(requestParameters['updateQuestConfigPrerequisitesBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuestConfigResponseFromJSON(jsonValue));
    }

    /**
     * Replace only a quest config\'s prerequisites (the Journey Editor\'s edge write). Milestones, rewards, and all other fields are left untouched.
     */
    async updateQuestConfigsIdPrerequisites(requestParameters: UpdateQuestConfigsIdPrerequisitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuestConfigResponse> {
        const response = await this.updateQuestConfigsIdPrerequisitesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetQuestConfigsIsActiveEnum = {
    True: 'true',
    False: 'false',
    All: 'all'
} as const;
export type GetQuestConfigsIsActiveEnum = typeof GetQuestConfigsIsActiveEnum[keyof typeof GetQuestConfigsIsActiveEnum];
/**
 * @export
 */
export const GetQuestConfigsIsSponsoredEnum = {
    True: 'true',
    False: 'false',
    All: 'all'
} as const;
export type GetQuestConfigsIsSponsoredEnum = typeof GetQuestConfigsIsSponsoredEnum[keyof typeof GetQuestConfigsIsSponsoredEnum];
/**
 * @export
 */
export const GetQuestConfigsPlayableAdsIsActiveEnum = {
    True: 'true',
    False: 'false',
    All: 'all'
} as const;
export type GetQuestConfigsPlayableAdsIsActiveEnum = typeof GetQuestConfigsPlayableAdsIsActiveEnum[keyof typeof GetQuestConfigsPlayableAdsIsActiveEnum];
/**
 * @export
 */
export const GetQuestConfigsPlayableAdsExistsIsActiveEnum = {
    True: 'true',
    False: 'false',
    All: 'all'
} as const;
export type GetQuestConfigsPlayableAdsExistsIsActiveEnum = typeof GetQuestConfigsPlayableAdsExistsIsActiveEnum[keyof typeof GetQuestConfigsPlayableAdsExistsIsActiveEnum];
